<template>
	<app-page>
		<app-heading title="Notification Subscribers">
			<template v-slot:left>
				<app-button v-if="$ravello.can('notification.post')"
					class="d-none d-sm-inline-flex"
					color="success"
					small
					outlined
					:to="{ name: 'subscriber', params: { subscriber: 'new' } }"
				>Add Subscriber</app-button>
			</template>
		</app-heading>
		<app-row>
			<app-cell>
				<app-data-table
					:items="subscribers"
					:headers="headers"
					:total="count"
					:refresh.sync="refresh"
					@update="fetchSubscribers"
				>
					<template v-slot:tags="{ item }">
						<span v-if="!item.tags || !item.tags.length">All tags</span>
						<span v-else>
							<app-chip
								class="mr-1"
								v-for="(tag, i) in item.tags"
								:key="`tags-${item._id}-${i}`"
							>{{tag}}
							</app-chip>
						</span>
					</template>
					<template v-slot:types="{ item }">
						<span v-if="!item.types || !item.types.length">None</span>
						<span v-else>
							<app-chip
								class="mr-1"
								v-for="(type, i) in getTypeNames(item.types)"
								:key="`types-${item._id}-${i}`"
							>{{type}}
							</app-chip>
						</span>
					</template>
					<template v-slot:actions="{ item }">
						<app-button
							v-if="$ravello.can('notification.put')"
							color="secondary"
							:to="{ name: 'subscriber', params: { subscriber: item._id } }"
							icon="fa-pencil-alt"
							table
						>
							Edit
						</app-button>
						<app-button-confirm
							v-if="$ravello.can('notification.delete')"
							color="error"
							icon="fa-trash"
							table
							label-confirm="Remove"
							:description="`Are you sure you want to remove subscriber`
								+ ` <b>${item.email}</b>?`"
							title="Remove Subscriber"
							@click="onDelete(item._id)"
						>
							Remove
						</app-button-confirm>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
		<app-floating-button
			class="d-inline-flex d-sm-none"
			:to="{ name: 'subscriber', params: { subscriber: 'new' } }"
			color="success"
			icon="fa-plus"
		/>
	</app-page>
</template>

<script>
import { mapDataSourceFields } from '@/utils/maps'

export default {
	async created() {
		this.types = mapDataSourceFields(await this.$ravello.request()
			.to('notifications')
			.to('types')
			.dataSource(), 'text', { key: 'value' })
	},
	computed: {
		group() {
			return this.$route.params.group
		},
	},
	data() {
		return {
			types: {},
			subscribers: [],
			count: -1,
			refresh: false,
			headers: [{
				text: 'Email',
				value: 'email',
				sortable: true,
				cb: item => item.email || 'None',
			}, {
				text: 'Webhook URL',
				value: 'webhook',
				sortable: true,
				format: 'ellipsis',
				formatArgs: [30],
				cb: item => item.webhook || 'None',
			}, {
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Tags',
				value: 'tags',
				sortable: false,
			}, {
				text: 'Subscriber Type',
				value: 'subscriber_type',
				sortable: false,
				cb: item => this.getSubscriberType(item),
			}, {
				text: 'Notification Types',
				value: 'types',
				sortable: false,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	methods: {
		async fetchSubscribers(pagination) {
			const request = this.$ravello.request()
				.to('notifications')
				.to('subscribers')
				.fromPagination(pagination)
				.param('group', this.group)

			try {
				this.subscribers = await request.get()
				if (this.count === -1) {
					const count = await request.count()
					this.count = count.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.to('notifications')
					.to('subscribers')
					.to(id)
					.delete()
				this.refresh = true
				this.$notifications.pushAlert('success', 'Subscriber successfully deleted')
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},

		getTypeNames(types) {
			return types.map(type => this.types[type] || '')
		},

		getSubscriberType(subscriber) {
			if (subscriber.user_id) {
				return 'User'
			}
			if (subscriber.webhook) {
				return 'Webhook'
			}

			return 'External'
		},
	},
}
</script>
